module.exports = __webpack_public_path__ + "img/toggle.281559a0.svg";